<div class="login-shell">
  <!-- Theme + language toggles flottants -->
  <div class="theme-corner">
    <app-language-switcher></app-language-switcher>
    <vd-theme-toggle></vd-theme-toggle>
  </div>

  <!-- Auroras animées -->
  <div class="auroras" aria-hidden="true">
    <span class="aurora a1"></span>
    <span class="aurora a2"></span>
    <span class="aurora a3"></span>
  </div>

  <!-- Side hero (desktop only) -->
  <aside class="hero-side">
    <div class="hero-content vd-fade-in-up">
      <div class="hero-logo-orbit">
        <span class="orbit o1"></span>
        <span class="orbit o2"></span>
        <app-brand-logo size="2xl" [animated]="true"></app-brand-logo>
      </div>
      <h1 class="hero-title" [innerHTML]="'login.hero_title_html' | transloco"></h1>
      <p class="hero-sub">
        {{ 'login.hero_sub' | transloco }}
      </p>

      <ul class="hero-points">
        <li>
          <span class="bullet b-primary">
            <span class="material-icons-outlined">forum</span>
          </span>
          {{ 'login.point_inbox' | transloco }}
        </li>
        <li>
          <span class="bullet b-accent">
            <span class="material-icons-outlined">local_shipping</span>
          </span>
          {{ 'login.point_shipping' | transloco }}
        </li>
        <li>
          <span class="bullet b-violet">
            <span class="material-icons-outlined">insights</span>
          </span>
          {{ 'login.point_kpi' | transloco }}
        </li>
        <li>
          <span class="bullet b-cyan">
            <span class="material-icons-outlined">smart_toy</span>
          </span>
          {{ 'login.point_bot' | transloco }}
        </li>
      </ul>
    </div>
  </aside>

  <!-- Login form -->
  <main class="login-card-wrap">
    <form class="login-card vd-scale-in" [formGroup]="loginForm" (ngSubmit)="onLogin()" novalidate>
      <div class="mobile-logo">
        <app-brand-logo size="lg" [animated]="true" [showWordmark]="true"></app-brand-logo>
      </div>

      <header class="form-head">
        <h2>{{ 'login.title' | transloco }}</h2>
        <p>{{ 'login.subtitle' | transloco }}</p>
      </header>

      <!-- SSO buttons -->
      <div class="sso-row">
        <button type="button" class="sso-btn sso-codincloud" (click)="loginWithCodinCloud()">
          <span class="sso-icon">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
              <circle cx="12" cy="12" r="10" fill="url(#cc-grad)"/>
              <defs>
                <linearGradient id="cc-grad" x1="0" y1="0" x2="24" y2="24">
                  <stop stop-color="#6366f1"/>
                  <stop offset="1" stop-color="#06b6d4"/>
                </linearGradient>
              </defs>
              <path d="M8 12L16 12M12 8L12 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </span>
          {{ 'login.continue_with_cc' | transloco }}
        </button>

        <button type="button" class="sso-btn sso-facebook" (click)="loginWithFacebook()" [title]="'login.sso_facebook' | transloco" aria-label="Continuer avec Facebook">
          <span class="sso-icon material-icons-outlined">facebook</span>
        </button>

        <button type="button" class="sso-btn sso-google" (click)="loginWithGoogle()" [title]="'login.sso_google' | transloco" aria-label="Continuer avec Google">
          <span class="sso-icon">
            <svg viewBox="0 0 18 18" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
              <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
            </svg>
          </span>
        </button>
      </div>

      <div class="divider"><span>{{ 'login.or_with_email' | transloco }}</span></div>

      <!-- Email -->
      <label class="field" [class.focused]="emailFocused" [class.has-value]="loginForm.get('email')?.value">
        <span class="field-icon material-icons-outlined">mail</span>
        <input
          type="email"
          formControlName="email"
          placeholder=" "
          autocomplete="email"
          (focus)="emailFocused = true"
          (blur)="emailFocused = false"
          required
        />
        <span class="field-label">{{ 'auth.email' | transloco }}</span>
      </label>

      <!-- Password -->
      <label class="field" [class.focused]="passwordFocused" [class.has-value]="loginForm.get('password')?.value">
        <span class="field-icon material-icons-outlined">lock</span>
        <input
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          placeholder=" "
          autocomplete="current-password"
          (focus)="passwordFocused = true"
          (blur)="passwordFocused = false"
          required
        />
        <span class="field-label">{{ 'auth.password' | transloco }}</span>
        <button
          type="button"
          class="reveal-btn"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="(showPassword ? 'login.hide_password' : 'login.show_password') | transloco"
        >
          <span class="material-icons-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </label>

      <div class="row-actions">
        <a routerLink="/mot-de-passe-oublie" class="link">{{ 'auth.forgot_password' | transloco }}</a>
      </div>

      <vd-button
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [loading]="isLoading"
        [disabled]="loginForm.invalid"
        (click)="onLogin()"
      >
        {{ 'auth.sign_in' | transloco }}
        <span slot="trailing" class="material-icons-outlined" *ngIf="!isLoading">arrow_forward</span>
      </vd-button>

      <p class="error-msg" *ngIf="errorMessage" @fadeInOut>
        <span class="material-icons-outlined">error_outline</span>
        {{ errorMessage }}
      </p>

      <p class="signup-cta">
        {{ 'auth.no_account' | transloco }}
        <a routerLink="/signup" class="link link-strong">{{ 'auth.create_account' | transloco }}</a>
      </p>

      <!-- Accès séparé agent / staff -->
      <button type="button" class="access-switch" (click)="openAccessModal()">
        <span class="material-icons-outlined">badge</span>
        Agent ou staff&nbsp;vendeur.site&nbsp;?
      </button>
    </form>
  </main>

  <!-- Modal : choix d'accès agent (public) vs staff (VPN) -->
  <div class="access-overlay" *ngIf="showAccessModal" @fadeInOut (click)="closeAccessModal()">
    <div class="access-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-label="Choisir un type d'accès">
      <button type="button" class="access-close" (click)="closeAccessModal()" aria-label="Fermer">
        <span class="material-icons-outlined">close</span>
      </button>

      <header class="access-head">
        <h3>Quel est votre profil&nbsp;?</h3>
        <p>Choisissez votre espace de connexion.</p>
      </header>

      <div class="access-grid">
        <!-- Agent (vendeur) -->
        <button type="button" class="access-card" (click)="goAgent()">
          <span class="access-ic ic-agent material-icons-outlined">point_of_sale</span>
          <span class="access-card-title">Agent</span>
          <span class="access-card-sub">Personnel d'un vendeur — caisse, préparation, stock, livraison, support.</span>
          <span class="access-tag tag-public">
            <span class="material-icons-outlined">public</span> Accès public
          </span>
        </button>

        <!-- Staff (vendeur.site) -->
        <button type="button" class="access-card" (click)="goStaff()">
          <span class="access-ic ic-staff material-icons-outlined">verified_user</span>
          <span class="access-card-title">Staff vendeur.site</span>
          <span class="access-card-sub">Personnel de la plateforme — supervision, support multi-vendeurs.</span>
          <span class="access-tag tag-vpn">
            <span class="material-icons-outlined">vpn_lock</span> VPN requis
          </span>
        </button>
      </div>

      <p class="access-foot">
        Vous êtes un vendeur&nbsp;? Utilisez le formulaire de connexion habituel.
      </p>
    </div>
  </div>

</div>
